'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClock, iconClockTag } from '@ni/nimble-components/dist/esm/icons/clock';
import { wrap } from '../../utilities/react-wrapper';

export type { IconClock };
export { iconClockTag };
export const NimbleIconClock = wrap(IconClock);